import http from 'src/app/http';


const getJobSuggestions = (query, limit = 5) => http.get('/jobtitle', { params: { limit, query } });

const getEmployerSuggestions = (query, limit = 5) => http.get('/employer', { params: { limit, query } });

const getCitySuggestions = (query, limit = 5) =>
  http.get('/autocomplete/geoLocations', { params: { query, top: limit } });


export default {
  getJobSuggestions,
  getEmployerSuggestions,
  getCitySuggestions
};
